import Select from "react-select";
import { useField } from "formik";

const SelectOption = ({ label, options, multi = true, placeholder, ...props }) => {
  const [field, meta, helpers] = useField(props.name);
  const { setValue, setTouched } = helpers;

  const handleChange = (selected) => {
    if (multi) {
      // selected is Array<{value,label}>
      setValue(selected ? selected.map(o => o.value) : []);
    } else {
      // selected is one {value,label} or null
      setValue(selected ? selected.value : "");
    }
  };

  // Determine the value prop for react-select:
  const value = multi
    ? options.filter(o => (field.value || []).includes(o.value))
    : options.find(o => o.value === field.value) || null;

  return (
    <div className="mb-3">
      <label htmlFor={props.name}>{label}</label>
      <Select
        id={props.name}
        name={props.name}
        options={options}
        isMulti={multi}
        value={value}              // ← enable multi-select
        onChange={handleChange}         // ← get Array<options> or null
        onBlur={() => setTouched(true)}
        placeholder={placeholder}
        isSearchable
      />
      {meta.touched && meta.error ? (
        <div style={{ color: "red" }}>{meta.error}</div>
      ) : null}
    </div>
  );
};
export default SelectOption;
